/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useServiceService } from 'domain/shared/service';
import { CreateForm } from 'framework/form';
import { useServiceUrl } from 'domain/shared/service';
import CreateServiceBreadcrumbs from 'domain/organization/service/createupdate/Create/Breadcrumbs';
import ServiceForm from 'domain/organization/service/createupdate/ServiceForm';

const CreateProject = () => {
  const { createService, getValidationSchema } = useServiceService();
  const { getListUrl } = useServiceUrl();

  return (
    <CreateForm
      submitFormFunc={createService}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Service has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Service" breadcrumbs={<CreateServiceBreadcrumbs />}>
        <ServiceForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateProject;
